module.exports = __webpack_public_path__ + "static/img/cont1.69222bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1.jpg
// module id = 29NO
// module chunks = 0